import React from 'react';
import ReactDOM from 'react-dom';
import './css/normalize.css';
import App from './App';

let startPage;
if (window.location.pathname.substring(1) === null || window.location.pathname.substring(1) === ""){
    startPage = "home";
} else {
    startPage = window.location.pathname.substring(1);
}
ReactDOM.render(<App startPath = {startPage} />, document.getElementById('main'));


// WEBPACK FOOTER //
// ./src/index.js